import React from 'react'
import { NoBroadCastIcon } from './NoBroadCastIcon'

import classes from './NoBroadCastBadge.module.scss'

export const NoBroadCastBadge = () => {
  return (
    <div className={classes.Container}>
      <NoBroadCastIcon />
      <span>No broadcast</span>
    </div>
  )
}
